import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { Util } from './../../util/util';
import { Component, AfterViewInit, OnInit, ElementRef, ViewChild, Renderer2, ViewEncapsulation, HostListener, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ConciergeItemsComponent } from 'src/pages/concierge/concierge-items/concierge-items';
import { Events } from 'src/providers/events/events';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { ContactInfoPage } from 'src/pages/more/contact-info/contact-info';
import { Client } from 'src/providers/client/client';
import { Pros } from 'src/providers/pros/pros';
import { TidyAbbreviateLastName } from 'src/shared/pipes/tidy-abbr-lastname.pipe';
import { HeaderProvider } from 'src/providers/header/header';
import { ActivatedRoute, Router } from '@angular/router';
import { AddressChangeService } from 'src/providers/address-change/address-change';
import { EmployerService } from "src/providers/employer/employer";
import { Me } from 'src/providers/me/me';

import { MyProPage } from 'src/pages/my-pros/my-pro/my-pro';
import { ConciergePage } from 'src/pages/concierge/concierge';
import { EmployerEditEmployeePage } from 'src/pages/employer/edit-employee/edit-employee';
import { BookService } from 'src/shared/services/book.service';
import { SubscriptionsPage } from 'src/pages/subscription/subscription';

import { TranslationPipe } from 'src/shared/pipes/translation.pipe';
import { ModalController } from '@ionic/angular';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { propertyDashboardPath } from 'src/providers/guard/rental-routes.guard';
import { Subscription } from 'rxjs';
import { notificationCenterDropDownMenu, NotificationCenterPage } from 'src/pages/notification-center/notification-center';
import * as confetti from 'canvas-confetti';
import { spookyConfetti } from 'src/shared/util/halloween';
import { NotificationsQueriesService } from 'src/shared/services/notifications-queries.service';
import { ChangeSubscriptionPage } from 'src/pages/subscription/change-subscription/change-subscription';

@Component({
    selector: 'app-header',
    templateUrl: './header.html',
    styleUrls: ['./header.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  backgroundColor: string;
  oldCompletedGoals: number;
  showOnboardingSubscription$: Subscription;
  showOnboarding = false;
  completedGoals = 0;
  totalGoals = 0;
  currentRoute: any;
  logo = '/assets/img/bowtie-white.svg';
  form: UntypedFormGroup;
  showHelpDropdown = false;
  showInitialsDropdown = false;
  userName: string;
  isEmployerAccount: boolean;
  imutableSearchItems = [];
  searchItems = [];
  showGlowAnimation: boolean;
  isInitialLoad: boolean;
  initials = '';
  isAccountSuspended: boolean;
  notificationsIcon = 'assets/img/notification-white.svg';
  subscription: any;
  hasNegativeBalance: boolean;
  showNegativeBalanceGlowAnimation: boolean;
  @ViewChild('searchInput', { read: ElementRef }) searchInputEl: ElementRef;
  @ViewChild('helpIconRef') helpIconRef: ElementRef;
  @ViewChild('helpDropdownRef') helpDropdownRef: ElementRef;
  @ViewChild('initialsIconRef') initialsIconRef: ElementRef;
  @ViewChild('initialsDropdownRef') initialsDropdownRef: ElementRef;

  constructor(
    private elementRef: ElementRef,
    private addressChangeService: AddressChangeService,
    private employerService: EmployerService,
    private util: Util,
    private navCtrl: CustomNavController,
    public route: ActivatedRoute,
    private events: Events,
    private renderer: Renderer2,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    private client: Client,
    private cdr: ChangeDetectorRef,
    private pros: Pros,
    public headerProvider: HeaderProvider,
    private router: Router,
    private modalController: ModalController,
    public onboardingProvider: OnboardingProvider,
    private notificationsQueries: NotificationsQueriesService,
    private me: Me,
    private bookService: BookService
  ) {
    this.form = new UntypedFormGroup({
      search: new UntypedFormControl(''),
    });
  }

  async ngOnInit(): Promise<void> {
    this.backgroundColor = '#1D2125';
    document.documentElement.style.setProperty('--header-background', this.backgroundColor);
    this.isEmployerAccount = localStorage.getItem('accountType') === 'employer';
    this.getLogo();
    this.getUserName();
    this.getSearchItems();
    this.watchSearchItemsChanges();
    this.renderer.listen('document', 'click', (event) => {
      this.onDocumentClick(event);
    });
    this.showOnboarding = true;
    this.setOnboardinGoalCount();
    this.isInitialLoad = true;
    if (localStorage.getItem('accountType') === 'rental') {
      await this.getSubscriptionInfo();
    }
    this.onboardingProvider.getShowOnboardingInHeader().subscribe(async (show) => {
      if (!this.isInitialLoad) {
        this.oldCompletedGoals = this.completedGoals;
        await this.setOnboardinGoalCount();
        this.showOnboarding = show;
        if (this.showOnboarding && this.completedGoals > this.oldCompletedGoals) {
          this.throwConfetti();
          this.showGlowAnimation = true;
        }
      }
      this.isInitialLoad = false;
      setTimeout(() => {
        this.showGlowAnimation = false;
      }, 1000);
    });
  }

  async getSubscriptionInfo() {
    const [subscriptions, hasNegativeBalance, me] = await Promise.all([
      this.me.getSubscriptions(),
      this.me.getHasNegativeBalance(),
      this.me.load(true)
    ]);
    this.hasNegativeBalance = hasNegativeBalance;
    this.isAccountSuspended = me.suspended_at ? true : false;
    if (subscriptions.length > 1) {
      subscriptions.map((subscription) => {
        if (subscription.is_activated_in_next_cycle) {
          this.subscription = subscription;
        } else {
          this.subscription = subscription;
        }
      });
    } else {
      this.subscription = subscriptions[0];
    }
    if (this.hasNegativeBalance) {
      this.showNegativeBalanceGlowAnimation = true;
      this.openRightSidePanel({}, ChangeSubscriptionPage);
      setTimeout(() => {
        this.showNegativeBalanceGlowAnimation = false;
      }, 1000);
    }
  }

  get notificationCount(): number {
    return this.notificationsQueries.notificationCount();
  }

  async setOnboardinGoalCount() {
    const goals = await this.storage.retrieve('onboardingGoals');
    if (goals) {
      this.completedGoals = this.getCompletedGoalCount(goals);
      this.totalGoals = goals.length;
    }
  }

  getCompletedGoalCount(goals) {
    return goals.filter((goal) => goal.state === 'done').length;
  }

  async toggleShowOnboarding() {
    this.showOnboarding = !this.showOnboarding;
    await this.storage.save('showOnboarding', this.showOnboarding);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.renderer.listen('document', 'click', (event) => {
        this.onDocumentClick(event);
      });
    });
  }

  onDocumentClick(event: Event) {
    if (this.searchInputEl && this.searchInputEl.nativeElement) {
      const clickedInside = this.searchInputEl.nativeElement.contains(event.target);
      if (!clickedInside) {
        this.form.patchValue({ search: '' });
        this.cdr.detectChanges();
      }
    }
  }

  onContainerClick(event: Event) {
    event.stopPropagation();
  }

  getLogo(): void {
    this.logo = '/assets/img/bowtie-white.svg';
  }

  async getUserName(): Promise<void> {
    const me = await this.client.getMe();
    this.userName = me?.current_user?.name || 'User';
    this.initials = this.parseInitials(this.userName);
  }

  parseInitials(fullName): string {
    return fullName
      .match(/(\b\S)?/g)
      .join('')
      .match(/(^\S|\S$)?/g)
      .join('')
      .toUpperCase();
  }

  async getSearchItems(): Promise<void> {
    if (this.isEmployerAccount) {
      const employees = await this.employerService.listEmployees();
      this.searchItems = [{
        list: 'EMPLOYEES',
        items: this.parseEmployees(employees)
      }];
      this.imutableSearchItems = this.searchItems;
    } else {
      const addressList = await this.client.getAddresses();
      const parsedAddressList = this.parseAddressList(addressList);
      const pros = await this.pros.getAllPros();
      const parsedPros = this.parsePros(pros);
      this.searchItems = [
        {
          list: 'PROPERTIES',
          items: parsedAddressList
        },
        {
          list: 'PROS',
          items: parsedPros
        },
        {
          list: 'PAGES',
          items: this.headerProvider.getSearchablePages()
        },
        {
          list: 'HELP ARTICLES',
          items: this.headerProvider.helpArticlesItems
        },
      ];
      this.imutableSearchItems = this.searchItems;
    }
  }

  parseEmployees(employees) {
    const array: any = [];
    employees.map((employee) => {
      array.push({
        title: `${employee?.source_user_first_name  } ${  employee?.source_user_last_name}`,
        image: 'assets/img/user-white.svg',
        isRightSidePanel: true,
        component: EmployerEditEmployeePage,
        params: {
          employee,
          shouldGetEmployeeBalance: true
        },
        link: 'employer-edit-employee'
      })
    });
    return array;
  }

  watchSearchItemsChanges(): void {
    this.form.valueChanges.subscribe((value) => {
      const newSearchItems = this.imutableSearchItems
        .map((item) => ({
            ...item,
            items: item.items.filter((i) =>
              (new TranslationPipe()).transform(i.title).toLowerCase().includes(value.search.toLowerCase()) || i?.searchTerms?.some(term => (new TranslationPipe()).transform(term).toLowerCase().includes(value.search.toLowerCase()))
            ),
          }))
        .filter((item) => item.items.length > 0);
      if (JSON.stringify(newSearchItems) !== JSON.stringify(this.searchItems)) {
        this.searchItems = newSearchItems;
      }
    });
  }

  parseAddressList(addressList) {
    return addressList.map((address) => {
      const addressName = this.getPropertyName(address);
      return {
        list: 'Properties',
        title: addressName,
        link: `properties?propertyId=${address.id}`,
        image: 'assets/img/house-white.svg'
      };
    });
  }

  parsePros(pros) {
    const prosItems = pros.map((pro) => ({
        list: 'Pros',
        title: pro?.name ? new TidyAbbreviateLastName().transform(pro.name) : '',
        link: `my-pro/${pro.id}`,
        image: 'assets/img/user-white.svg',
        isRightSidePanel: true,
        component: MyProPage,
        params: {
          proId: pro.id
        }
      }));
    return prosItems;
  }

  getPropertyName(address: any): string {
    if (address.address_name) {
      return address.address_name;
    }
    if (address?.address2 && address?.address2 !== '') {
      return `${address.address1}, ${address.address2}`;
    }
    return address.address1;
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (
      this.showHelpDropdown &&
      !this.helpIconRef.nativeElement.contains(event.target) &&
      !this.helpDropdownRef.nativeElement.contains(event.target)
    ) {
      this.showHelpDropdown = false;
    }
    if (
      this.showInitialsDropdown &&
      !this.initialsIconRef.nativeElement.contains(event.target) &&
      !this.initialsDropdownRef.nativeElement.contains(event.target)
    ) {
      this.showInitialsDropdown = false;
    }
  }

  toggleHelpDropdown(event: Event) {
    event.stopPropagation();
    this.rightSidePanelService.closeRightSidePanel();
    this.showHelpDropdown = !this.showHelpDropdown;
    this.showInitialsDropdown = false;
  }

  navigateToWhatsNew() {
    this.showHelpDropdown = false;
    this.util.openUrl('https://www.tidy.com/blog?tag=changelog');
  }

  navigateToDocuments() {
    this.showHelpDropdown = false;
    this.util.openUrl('https://www.tidy.com/docs/pm/getting-started');
  }

  navigateToConcierge() {
    this.headerProvider.showConciergePage = true;
    this.headerProvider.showNotificationCenter = false;
    this.showHelpDropdown = false;
    this.openRightSidePanel({}, ConciergePage);
  }

  navigateToNotificationCenter() {
    this.headerProvider.showConciergePage = false;
    this.headerProvider.showNotificationCenter = true;
    this.showHelpDropdown = false;
    this.openRightSidePanel({}, NotificationCenterPage, {dropDownMenu: notificationCenterDropDownMenu});
  }

  toggleInitialsDropdown(event: Event) {
    event.stopPropagation();
    this.rightSidePanelService.closeRightSidePanel();
    this.showInitialsDropdown = !this.showInitialsDropdown;
    this.showHelpDropdown = false;
  }

  navigateToProfile() {
    this.showInitialsDropdown = false;
  }

  logout(): void {
    localStorage.clear();
    this.events.publish('logout');
  }

  goToSubscriptionPage() {
    if (this.hasNegativeBalance) {
      this.openRightSidePanel({}, ChangeSubscriptionPage);
    } else {
      this.openRightSidePanel({}, SubscriptionsPage);
    }
  }

  goToAddSupportRequest(): void {
    this.showHelpDropdown = false;
    const component = ConciergeItemsComponent;
    const params = {
      title: 'Support Requests',
      type: null,
      isAddingItem: true,
    };
    this.openRightSidePanel(params, component);
  }

  goToContactInfo() {
    this.showInitialsDropdown = false;
    const component = ContactInfoPage;
    this.openRightSidePanel({}, component);
  }

  async openRightSidePanel(params, component, data = {}) {
    await this.storage.save('shouldUpdateItems', false);
    const dialogParams = await this.storage.retrieve('dialog-params');
    params = {
      ...dialogParams,
      ...params,
    };
    await this.storage.save('dialog-params', params);
    await this.storage.save('dialog-right-side-open', true);
    this.rightSidePanelService.openRightSidePanel(component, data);
  }

  async handleClickItem(item) {
    this.form.patchValue({ search: '' });
    if (item.title === 'Book Job(s)') {
      await this.bookService.goToBookJob({});
      return;
    }
    if (item?.link) {
      if (item?.link.includes('https://')) {
        this.util.openUrl(item.link);
      } else {
        if (item.isRightSidePanel) {
          this.storage.save('dialog-right-side-open', true);
          this.storage.save('dialog-params', item?.params);
          this.rightSidePanelService.openRightSidePanel(item?.component);
        } else {
          if (item.link.startsWith('properties?propertyId=') && this.router.url.startsWith(propertyDashboardPath())) {
            const propertyIdMatch = item.link.match(/propertyId=(\d+)/);
            if (propertyIdMatch) {
              this.addressChangeService.changeAddress(parseInt(propertyIdMatch[1]));
            }
          } else {
            this.navCtrl.navigateForward(item.link);
          }
        }
      }
    }
  }

  async openOnboarding() {
    this.rightSidePanelService.closeRightSidePanel();
    if (this.onboardingProvider.showOnboarding && this.onboardingProvider.flow !== 'createConciergeRules' && this.onboardingProvider.flow !== 'selectAccessNotes') {
      this.onboardingProvider.previousOnboardingFlow = this.onboardingProvider.flow;
    }
    this.onboardingProvider.page = 'goals';
    this.onboardingProvider.flow = 'goals';
    await this.onboardingProvider.refreshOnboardingContent();
    this.onboardingProvider.showOnboarding = true;
    this.onboardingProvider.setShowOnboardingOnPage(true);
    this.watchShowOnboarding();
  }

  watchShowOnboarding() {
    this.showOnboardingSubscription$ = this.onboardingProvider.getShowOnboardingOnPage().subscribe((show) => {
      this.onboardingProvider.showOnboarding = show;
    });
  }

  async throwConfetti() {
    const canvas = this.renderer.createElement('canvas');
    canvas.style.position = 'fixed';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '9999';
    this.renderer.appendChild(document.body, canvas);
    const confettiAnimation = confetti.create(canvas, { resize: true });
    try {
      await confettiAnimation(spookyConfetti({
        particleCount: 150,
        spread: 180,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        origin: { x: 0.5, y: 0.5 },
      }));
    } catch (_error) {
      // Silent error - confetti animation failure is not critical
    }
    this.renderer.removeChild(document.body, canvas);
  }

  ngOnDestroy() {
    if (this.showOnboardingSubscription$) {
      this.onboardingProvider.previousOnboardingFlow = null;
      this.showOnboardingSubscription$.unsubscribe();
    }
  }

}